// AnggaranPage.js
import React, { useEffect, useMemo, useState, useCallback } from "react";
import Sidebar from "../../Component/Sidebar/Sidebar";
import Header from "../../Component/Header/Header";
import Anggaran from "../../Component/Anggaran/Anggaran";
import "./anggaranpage.css";

export default function AnggaranPage() {
  // Deteksi mobile (≤1024px) pakai matchMedia
  const getIsMobile = () =>
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 1024px)").matches;

  const [isMobile, setIsMobile] = useState(getIsMobile());
  // Desktop: default sidebar terbuka, Mobile: default tertutup
  const [isSidebarOpen, setIsSidebarOpen] = useState(!getIsMobile());

  // Re-evaluate saat resize
  useEffect(() => {
    const mql = window.matchMedia("(max-width: 1024px)");
    const onChange = (e) => setIsMobile(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  // Sinkronkan state saat breakpoint berubah
  useEffect(() => {
    // Di mobile: tutup sidebar by default; di desktop: buka
    setIsSidebarOpen(!isMobile);
  }, [isMobile]);

  // Helper: tambahkan/hapus kelas ke elemen DOM agar cocok dengan CSS
  const applyDomClasses = useCallback(
    (open) => {
      const body = document.body;
      const sidebarEl = document.querySelector(".anggaran-page .sidebar");
      const overlayEl = document.querySelector(".anggaran-page .sidebar-overlay");

      if (isMobile) {
        if (open) {
          sidebarEl?.classList.add("is-mobile-open");
          overlayEl?.classList.add("is-visible");
          body.classList.add("lock-scroll");
        } else {
          sidebarEl?.classList.remove("is-mobile-open");
          overlayEl?.classList.remove("is-visible");
          body.classList.remove("lock-scroll");
        }
      } else {
        // Desktop: pastikan tidak ada kelas mobile yang tertinggal
        sidebarEl?.classList.remove("is-mobile-open");
        overlayEl?.classList.remove("is-visible");
        body.classList.remove("lock-scroll");
      }
    },
    [isMobile]
  );

  // Terapkan kelas setiap kali state berubah
  useEffect(() => {
    applyDomClasses(isSidebarOpen);
  }, [isSidebarOpen, applyDomClasses]);

  // Toggle handler (dipakai Header burger)
  const toggleSidebar = useCallback(() => {
    setIsSidebarOpen((prev) => !prev);
  }, []);

  // Klik overlay menutup sidebar
  const handleOverlayClick = () => setIsSidebarOpen(false);

  // Kelas main-content:
  // - Desktop: ikut .sidebar-open / .sidebar-closed (geser konten)
  // - Mobile: selalu full width (biar off-canvas)
  const mainContentClass = useMemo(() => {
    if (isMobile) return "main-content sidebar-closed";
    return `main-content ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`;
  }, [isMobile, isSidebarOpen]);

  return (
    <div className="anggaran-page">
      {/* Sidebar harus memiliki class .sidebar di root komponennya agar CSS bekerja.
          Jika Sidebar kamu sudah render <aside class="sidebar">... berarti aman.
          Kalau belum, tambahkan className="sidebar" di komponennya. */}
      <Sidebar isOpen={isSidebarOpen} />

      {/* Overlay untuk mobile off-canvas */}
      <div
        className="sidebar-overlay"
        onClick={handleOverlayClick}
        aria-hidden={!isSidebarOpen}
      />

      <div className={mainContentClass}>
        <Header toggleSidebar={toggleSidebar} />
        <div className="page-container">
          <div className="agr-content">
            <Anggaran />
          </div>

          <footer className="dashboard-footer">
            <p>@copyright 2025 - LacaKas</p>
          </footer>
        </div>
      </div>
    </div>
  );
}
